export const CREATE_USER_REQUEST = 'CREATE_USER_REQUEST';
export const CREATE_USER_SUCCESS = 'CREATE_USER_SUCCESS';
export const CREATE_USER_FAILURE = 'CREATE_USER_FAILURE';
export const GET_ACTIVE_PROPERTIES_FOR_SALE_REQUEST = 'GET_ACTIVE_PROPERTIES_FOR_SALE_REQUEST';
export const GET_ACTIVE_PROPERTIES_FOR_SALE_SUCCESS = 'GET_ACTIVE_PROPERTIES_FOR_SALE_SUCCESS';
export const GET_ACTIVE_PROPERTIES_FOR_SALE_FAILURE = 'GET_ACTIVE_PROPERTIES_FOR_SALE_FAILURE';
export const GET_ACTIVE_PROPERTIES_FOR_RENT_REQUEST = 'GET_ACTIVE_PROPERTIES_FOR_RENT_REQUEST';
export const GET_ACTIVE_PROPERTIES_FOR_RENT_SUCCESS = 'GET_ACTIVE_PROPERTIES_FOR_RENT_SUCCESS';
export const GET_ACTIVE_PROPERTIES_FOR_RENT_FAILURE = 'GET_ACTIVE_PROPERTIES_FOR_RENT_FAILURE';
export const GET_DEVELOPMENT_PROPERTIES_REQUEST = 'GET_DEVELOPMENT_PROPERTIES_REQUEST';
export const GET_DEVELOPMENT_PROPERTIES_SUCCESS = 'GET_DEVELOPMENT_PROPERTIES_SUCCESS';
export const GET_DEVELOPMENT_PROPERTIES_FAILURE = 'GET_DEVELOPMENT_PROPERTIES_FAILURE';
export const GET_LUXURY_PROPERTIES_REQUEST = 'GET_LUXURY_PROPERTIES_REQUEST';
export const GET_LUXURY_PROPERTIES_SUCCESS = 'GET_LUXURY_PROPERTIES_SUCCESS';
export const GET_LUXURY_PROPERTIES_FAILURE = 'GET_LUXURY_PROPERTIES_FAILURE';
export const GET_ALL_SELLERS_SUCCESS = 'GET_ALL_SELLERS_SUCCESS';
export const GET_ALL_SELLERS_FAIL = 'GET_ALL_SELLERS_FAIL';
export const GET_ALL_MARTILLERS_SUCCESS = 'GET_ALL_MARTILLERS_SUCCESS';
export const GET_ALL_MARTILLERS_FAIL = 'GET_ALL_MARTILLERS_FAIL';
